module.exports = __webpack_public_path__ + "img/ship-3.18a3f2b2.jpg";